export const removeProtocol = (uri: string) => {
  try {
    let uriForParsing = uri
    if (!uri.startsWith('http://') && !uri.startsWith('https://')) {
      uriForParsing = 'https://' + uri // Add a temporary protocol for parsing
    }

    const url = new URL(uriForParsing)
    const path = url.pathname.replace(/\/$/, '') // Remove trailing slash
    return url.host + (path ? path : '')
  } catch {
    return uri
  }
}

export const createTrackingScript = (apiKey: string, trackingUrl: string, debug: boolean) =>
  `<script type="text/javascript">
  (function () {
    if (window.Innkeepr && Object.keys(window.Innkeepr).includes('load')) {
      // Now we assume Innkeepr is already loaded
      console.warn('Detected attempt to load Innkeepr multiple times.');
      return;
    }
    var innkeepr = (window.Innkeepr = []);

    innkeepr.methods = ['identify', 'track', 'getCookie'];

    innkeepr.factory = function (method) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        innkeepr.push(args);
        return innkeepr;
      };
    };

    for (var i = 0; i < innkeepr.methods.length; i++) {
      var key = innkeepr.methods[i];
      innkeepr[key] = innkeepr.factory(key);
    }

    innkeepr.load = function (apiKey, apiUrl, debugMode) {
      // Create an async script element based on your key.
      innkeepr.apiKey = apiKey;
      innkeepr.apiUrl = apiUrl;
      innkeepr.debugMode = debugMode;
      var script = document.createElement('script');
      script.type = 'application/javascript';
      script.async = true;
      script.src = 'https://${removeProtocol(trackingUrl.trim()) || 'cdn.innkeepr.ai'}/innkeepr.js';

      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
    };

    innkeepr.SNIPPET_VERSION = '1.2.0';

    // Load Innkeepr.js with your key
    innkeepr.load('${apiKey}', 'https://api.innkeepr.ai', ${debug});
  })();
</script>`
